import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import Pack_Courses from '@/classes/Packs_Courses/Pack_Courses.class';

export const usePacksCoursesStore = defineStore('packsCourses', {
    state: () => ({
        id_module: null,
        list: [],
    }),
    actions: {

        async fetchAll() {
            this.list = [];
            let res = await PublicService.getPacksCourses(this.id_module);
            if (res) {
                this.set(res);
            }
        },
        set(data) {
            this.list = [];
            for (let i = 0; i < data.length; i++) {
                let pack = new Pack_Courses();
                pack.set(data[i]);
                this.list.push(pack);
            }
        }
    },
    getters: {

    },
});